var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "small" },
        [
          _c("span", { domProps: { innerHTML: _vm._s(_vm.label) } }),
          _vm._v(" "),
          _vm.popin4xCb
            ? _c("ob1-liens", {
                attrs: {
                  text: _vm.popin4xCb.text,
                  "is-button": true,
                  "modal-id": "legal-mentions-popin-4xcb",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.popin4xCb
        ? _c("pxf-cb4x-modal", {
            attrs: {
              "modal-id": "legal-mentions-popin-4xcb",
              "display-cb4x": true,
              "display-pxf": false,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cb4x-content",
                  fn: function () {
                    return [
                      _c("cb4x-modal-content", {
                        attrs: {
                          "header-block": _vm.popin4xCb.headerBlock,
                          "payment-example-block":
                            _vm.popin4xCb.paymentExampleBlock,
                          "payment-simulation-block":
                            _vm.popin4xCb.paymentSimulationBlock,
                          "how-to-benefit": _vm.popin4xCb.howToBenefit,
                          faq: _vm.popin4xCb.faqBlock,
                          cgu: _vm.popin4xCb.cgu,
                          "monthly-price": _vm.popin4xCb.monthlyPrice,
                          "first-monthly-price":
                            _vm.popin4xCb.firstMonthlyPrice,
                          "one-shot-price": _vm.popin4xCb.oneShotPrice,
                          tms:
                            _vm.popin4xCb && _vm.popin4xCb.tms
                              ? _vm.popin4xCb.tms
                              : {},
                          illustration: _vm.popin4xCb.imageZen,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2986565733
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }